import { EmptyStateImages } from '../../../components/common';
import { HELP_LINKS } from '../../../constants/HelpLinks';
import { AddFilesToBoardButton } from './buttons/AddFilesToBoardButton';
import { ExploreShutterstockButton } from './buttons/ExploreShutterstockButton';
import { GetAppButton } from './buttons/GetAppButton';
import { SiteFilesNewDnDButton } from './buttons/SiteFilesNewDnDButton';
import { TryAgainButton } from './buttons/TryAgainButton';
import { LearnMoreLink } from './buttons/LearnMoreLink/LearnMoreLink';
import { EmptyStateType, TConfigMapper } from './EmptyState.types';
import { FavoritesSubtitle } from './subtitles/FavoritesSubtitle';
import { MobileSubtitle } from './subtitles/MobileSubtitle';
import { NetworkErrorSubtitle } from './subtitles/NetworkErrorSubtitle';
import { NewNotAuthorizedSubtitle } from './subtitles/NotAuthorizedSubtitle';
import { PurchasedSubtitle } from './subtitles/PurchasedSubtitle';
import { NewSearchSubtitle } from './subtitles/SearchSubtitle/SearchSubtitle';
import { SiteFilesNewDnDSubtitle } from './subtitles/SiteFilesNewDnDSubtitle/SiteFilesNewDnDSubtitle';
import { TrashSubtitle } from './subtitles/TrashSubtitle';
import { UnknownErrorSubtitle } from './subtitles/UnknownErrorSubtitle/UnknownErrorSubtitle';
import { VisitorUploadsSubtitle } from './subtitles/VisitorUploadsSubtitle';
import { BoardTitle } from './titles/BoardTitle';
import { FavoritesTitle } from './titles/FavoritesTitle';
import { MobileTitle } from './titles/MobileTitle';
import { NetworkErrorTitle } from './titles/NetworkErrorTitle';
import { NewNotAuthorizedTitle } from './titles/NotAuthorizedTitle';
import { PurchasedTitle } from './titles/PurchasedTitle';
import { SearchTitle } from './titles/SearchTitle';
import { SiteFilesNewDnDTitle } from './titles/SiteFilesNewDnDTitle';
import { TrashTitle } from './titles/TrashTitle';
import { UnknownErrorTitle } from './titles/UnknownErrorTitle';
import { VisitorUploadsTitle } from './titles/VisitorUploadsTitle';
import { BoardSubtitle } from './subtitles/BoardSubtitle/BoardSubtitle';
import { SearchButtons } from './buttons/SearchButtons';
import { RefreshButton } from './buttons/RefreshButton';

export const EmptyStatesConfigs: TConfigMapper = {
  [EmptyStateType.SiteFilesNewDnD]: {
    image: EmptyStateImages.Archived,
    Title: SiteFilesNewDnDTitle,
    Subtitle: SiteFilesNewDnDSubtitle,
    Button: SiteFilesNewDnDButton,
  },

  [EmptyStateType.Offline]: {
    image: EmptyStateImages.NetworkUnstable,
    Title: NetworkErrorTitle,
    Subtitle: NetworkErrorSubtitle,
    Button: RefreshButton,
  },
  [EmptyStateType.Mobile]: {
    image: EmptyStateImages.Mobile,
    Title: MobileTitle,
    Subtitle: MobileSubtitle,
    Button: GetAppButton,
  },
  [EmptyStateType.Purchased]: {
    image: EmptyStateImages.Purchased,
    Title: PurchasedTitle,
    Subtitle: PurchasedSubtitle,
    Button: ExploreShutterstockButton,
  },
  [EmptyStateType.Favorites]: {
    image: EmptyStateImages.Favorites,
    Title: FavoritesTitle,
    Subtitle: FavoritesSubtitle,
  },
  [EmptyStateType.VisitorUploads]: {
    image: EmptyStateImages.VisitorUploads,
    Title: VisitorUploadsTitle,
    Subtitle: VisitorUploadsSubtitle,
  },
  [EmptyStateType.NetworkError]: {
    image: EmptyStateImages.NetworkUnstable,
    Title: NetworkErrorTitle,
    Subtitle: NetworkErrorSubtitle,
    Button: TryAgainButton,
    buttonProps: {
      message: 'empty-state.server-error-link',
    },
  },
  [EmptyStateType.NotAuthorized]: {
    image: EmptyStateImages.NotAuthorized,
    Title: NewNotAuthorizedTitle,
    Subtitle: NewNotAuthorizedSubtitle,
    Button: TryAgainButton,
    buttonProps: {
      message: 'empty-state.not-authorized-link',
    },
  },
  [EmptyStateType.UnknownError]: {
    image: EmptyStateImages.UnknownError,
    Title: UnknownErrorTitle,
    Subtitle: UnknownErrorSubtitle,
    Button: TryAgainButton,
    buttonProps: {
      message: 'empty-state.server-error-link',
    },
  },
  [EmptyStateType.Trash]: {
    image: EmptyStateImages.EmptyTrashImage,
    Title: TrashTitle,
    Subtitle: TrashSubtitle,
    Button: LearnMoreLink,
    buttonProps: {
      link: HELP_LINKS.LEARN_MORE_TRASH,
    },
  },
  [EmptyStateType.MediaFromWix]: {
    image: EmptyStateImages.Search,
    Title: SearchTitle,
    Subtitle: NewSearchSubtitle,
    Button: SearchButtons,
  },
  [EmptyStateType.Enterprise]: {
    image: EmptyStateImages.Search,
    Title: SearchTitle,
    Subtitle: NewSearchSubtitle,
    Button: SearchButtons,
  },
  [EmptyStateType.Shutterstock]: {
    image: EmptyStateImages.Search,
    Title: SearchTitle,
    Subtitle: NewSearchSubtitle,
    Button: SearchButtons,
  },
  [EmptyStateType.Search]: {
    image: EmptyStateImages.Search,
    Title: SearchTitle,
    Subtitle: NewSearchSubtitle,
    Button: SearchButtons,
  },
  [EmptyStateType.SearchBySource]: {
    image: EmptyStateImages.Search,
    Title: SearchTitle,
    Subtitle: NewSearchSubtitle,
    Button: SearchButtons,
  },
  [EmptyStateType.Board]: {
    image: EmptyStateImages.Board,
    Title: BoardTitle,
    Subtitle: BoardSubtitle,
    Button: AddFilesToBoardButton,
  },
};
